import { Outlet, createBrowserRouter } from "react-router-dom";
import MenuPage from "../pages/menu-page";
import ItemPage from "../pages/item-page";
import { MainProvider } from "../context";
import CartPage from "../pages/cart-page";
import { CartProvider } from "../pages/cart-page/context";
import Layout from "../layout";
import OrdersPage from "../pages/orders-page";
import HomePage from "../pages/home-page";
import ErrorPage from "../pages/error-page";

export const ROUTES = {
  HOME: "/",
  RESTAURANT: (restaurantId) => `/${restaurantId}`,
  ITEM: (restaurantId, id) => `/${restaurantId}/item/${id}`,
  CART: `/cart`,
  ORDERS: `/orders`,
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/",
    element: (
      <MainProvider>
        <Layout>
          <Outlet />
        </Layout>
      </MainProvider>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/:restaurantId",
        element: <MenuPage />,
      },
      {
        path: "/:restaurantId/item/:productId",
        element: <ItemPage />,
      },
      {
        path: "/cart",
        element: (
          <CartProvider>
            <CartPage />
          </CartProvider>
        ),
      },
      {
        path: "/orders",
        element: <OrdersPage />,
      },
    ],
  },
]);

export default router;
